import { render, staticRenderFns } from "./fileOpenButton.vue?vue&type=template&id=6d349671&"
import script from "./fileOpenButton.vue?vue&type=script&lang=ts&"
export * from "./fileOpenButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports